export default () => {
  const { $dayjs } = useNuxtApp();

  const day = (): string => $dayjs().format('HH:mm:ssA');
  const currentTime: globalThis.Ref<string> = ref(day());
  const updateCurrentTime = () => {
    currentTime.value = day();
  };
  const updateTimeInterval: NodeJS.Timeout = setInterval(
    updateCurrentTime,
    1000,
  );

  const clearClockInterval = () => clearInterval(updateTimeInterval);
  return { currentTime, clearClockInterval };
};
